module.exports = __webpack_public_path__ + "img/eg5.404869c2.png";